import { createContext, useState, useEffect } from "react";
import { doc, getDoc, setDoc  } from "firebase/firestore";
import { db } from '../firebaseConfig';

export const ConfigContext = createContext();


export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(null);

    useEffect(() => {
        const getConfig = async () => {
            const configRef = doc(db, 'config', "about");
            const configSnap = await getDoc(configRef);
            if (configSnap.exists) {
                let config = {
                    ...configSnap.data(),
                    id: configSnap.id
                }
                setConfig(config);
            }
        }
        getConfig();

    }, [])

    const updateConfig = async (about ) => {     
        const configRef = doc(db, 'config', "about");
        await setDoc(configRef, { ...about });
        setConfig(config);
    }


    return (
        <ConfigContext.Provider value={{ about: config, setAbout: setConfig, updateConfig }}>
            {children}
        </ConfigContext.Provider>
    )
}
